var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'text-success' :_vm.getOnOff, 'text-danger' :!_vm.getOnOff},attrs:{"title":"Indicação de conexão do browser com o servidor, vermelho esta desconectado e verde conectado"}},[_c('i',{staticClass:"fa fa-circle",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }